import type { CountryIso } from './country';
import type { LocaleIso } from './locale';

export function translateCountry(locale: LocaleIso, country: CountryIso): string {
  const context = new Intl.DisplayNames([locale], { type: 'region' });

  return context.of(country) as string;
}
